import _ = require("lodash");
import { CellType, ExcelColorValue, UploadStatus, Constants } from "../../util/UIConstants";
import { IColumnConfig } from "../configuration";
import { labels, currentResource } from "../../util/utils";
import Utility from "../../util/utilityFunctions";

export class DeficiencyConfiguration implements IColumnConfig {
  rowheader: any[];
  columns: any[];

  constructor() {
    this.columns = [
      {
        CellHeader: labels.status,
        CellId: "UploadStatus",
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.Black,
          RowsFillColor: ExcelColorValue.GrayColor,
        },
        getCellData: (data) => {
          return `${currentResource.uploadStatusLabels[UploadStatus.Downloaded]}`;
        },
      },
      {
        CellHeader: labels.updateCanvas,
        IsMarkValue: true,
        CellId: "MarkForUpdate",
        CellFormat: {
          locked: false,
          RowsFillColor: ExcelColorValue.White,
        },
        getCellData: (data) => {
          return Constants.MarkForUpdateNo;
        },
        referenceData: {
          getCellData: (userLanguage) => {
            return Utility.updateEYCanvasDropDownValues;
          },
        },
        cellToBindDropDown: true,
      },
      {
        CellHeader: labels.deficiencyTitle,
        CellId: "DeficiencyShortName",
        CellFormat: {
          locked: false,
          requiredColumnWidth: 168.66, //30 Width
          RowsFillColor: ExcelColorValue.White,
          horizontalAlignment: "Left",
          wrapText: true,
        },
        getCellData: (data) => {
          return data.deficiencyShortName;
        },
      },
      {
        CellHeader: labels.deficiencyDescription,
        CellId: "DeficiencyDescription",
        CellFormat: {
          locked: false,
          requiredColumnWidth: 278.27, //50 Width
          RowsFillColor: ExcelColorValue.White,
          horizontalAlignment: "Left",
          wrapText: true,
        },
        getCellData: (data) => {
          return data.description;
        },
      },
      {
        CellHeader: labels.deficiencyTitle + " ",
        CellId: "OriginalDeficiencyShortName",
        CellFormat: {
          locked: true,
          requiredColumnWidth: 168.66, //30 Width
          HeaderFillColor: ExcelColorValue.Black,
          RowsFillColor: ExcelColorValue.GrayColor,
          horizontalAlignment: "Left",
          wrapText: true,
        },
        getCellData: (data) => {
          return data.deficiencyShortName;
        },
      },
      {
        CellHeader: labels.deficiencyDescription + " ",
        CellId: "OriginalDeficiencyDescription",
        CellFormat: {
          locked: true,
          requiredColumnWidth: 278.27, //50 Width
          HeaderFillColor: ExcelColorValue.Black,
          RowsFillColor: ExcelColorValue.GrayColor,
          horizontalAlignment: "Left",
          wrapText: true,
        },
        getCellData: (data) => {
          return data.description;
        },
      },
      {
        CellHeader: labels.deficiencyCategory,
        CellId: "Category",
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.Black,
          RowsFillColor: ExcelColorValue.GrayColor,
          horizontalAlignment: "Left",
        },
        getCellData: (data) => {
          const dataObject = currentResource.deficiencyCategoryTypes.find((x) => x.value === data.entityID);
          return dataObject ? dataObject.label : "";
        },
      },
      {
        CellHeader: labels.deficiencyId + " ",
        CellId: "DeficiencyId",
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.Black,
          RowsFillColor: ExcelColorValue.GrayColor,
          columnHidden: true,
        },
        getCellData: (data) => {
          return data.id;
        },
      },
      {
        CellHeader: labels.hash,
        CellId: "HashValue",
        HashAttribue: {
          HashCalculatedDataattributesName: [
            {
              CellId: "DeficiencyShortName",
            },
            {
              CellId: "DeficiencyDescription",
            },
          ],
        },
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.Black,
          RowsFillColor: ExcelColorValue.GrayColor,
          columnHidden: true,
        },
        getCellData: (data) => {
          let hashValue: string = "";
          hashValue = Utility.getHashValueForRow(this.columns, [], data);
          return hashValue;
        },
      },
      {
        CellHeader: labels.statusId,
        CellType: CellType.DynamicCell,
        CellId: "UploadStatusId",
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.Black,
          RowsFillColor: ExcelColorValue.GrayColor,
          columnHidden: true,
        },
        getCellData: (data) => {
          return `${UploadStatus.Downloaded}`;
        },
      },
    ];
    this.rowheader = [
      {
        CellHeader: labels.referenceOnly,
        DisplayRange: ["A1:A1", "E1:J1"],
        CellFormat: {
          locked: true,
        },
      },
      {
        CellHeader: labels.columnsToUpdate,
        DisplayRange: ["B1:D1"],
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.GrayColor,
        },
      },
    ];
  }
}
